import { gql } from "@apollo/client";

export const getTreatyDebitAmountDue = gql`
  query GetTreatyDebitAmountDue($treatyAccountId: ID!, $default: Boolean) {
    getTreatyDebitAmountDue(
      treaty_account_id: $treatyAccountId
      default: $default
    ) {
      currency
      amount
      isCredit
      cashBalance
      orderHereon
      country
      overAllTotal
      totalPayment
      overAllPaymentTotal
      outstanding
      overAllOutstanding
    }
  }
`;
